

<div id="appVersion">
     {{ appVersion }}
 </div>